// src/pages/Faq.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './Faq.css';

const showQuestion = (event) => {
  const faqItem = event.currentTarget.closest('.faq-item');
  faqItem.classList.toggle('enabled');
};

const Faq = () => {
  return (
    <main className="page-faq">
      <section className="faq-section">
        <div className="page-content">


          <h1 className="section-title">Perguntas Frequentes</h1>

          {/* Exemplo de acordeões (simplificado) */}
          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">1. Como é feita a integração dos dados?</button>
            <div className="faq-answer">
              <p>
                Via exportação automática de arquivos CSV do sistema acadêmico/ERP da instituição. Fornecemos scripts
                que convertem ou criptografam esses dados antes do upload, garantindo segurança. A instituição fica no
                controle de quais dados inserir na Plataforma CODI.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">2. Preciso de um servidor local para a CODI?</button>
            <div className="faq-answer">
              <p>
                Não. A Plataforma CODI é hospedada em nuvem nacional (Brasil). Você acessa de qualquer navegador
                ou dispositivo com internet. A versão local, on-premise, ainda não está disponível.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">3. Quanto tempo leva para implantar?</button>
            <div className="faq-answer">
              <p>
                A parte técnica pode ser feita em poucos dias. Depois disso, existe uma fase de análise de coerência
                dos dados. Mesmo assim, a plataforma já fica funcional para uso inicial.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">4. Como funciona a questão de segurança e LGPD?</button>
            <div className="faq-answer">
              <p>
                A Plataforma CODI não recebe dados sensíveis (gênero, raça, religião etc.). Nos dados em trânsito
                ou em armazenamento, há criptografia, servidores com load balancer e backups diários. O acesso à
                Plataforma CODI é restrito pela rede da IES, com níveis de permissão.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">5. Qual a frequência de atualização dos dados?</button>
            <div className="faq-answer">
              <p>
                Geralmente diária, mas pode ser mais vezes ao dia, dependendo da automação configurada pela instituição.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">6. Como são feitos os atendimentos aos alunos pela CODI?</button>
            <div className="faq-answer">
              <p>
                A CODI usa um painel Kanban para facilitar a organização dos atendimentos e conta com funcionalidades
                inspiradas em CRM e BPM, incluindo atribuição de atendimentos, configurações de regras de fluxo
                entre os setores, automações de lembretes, registro de histórico e envio de mensagens.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">7. Vocês têm um modelo de preços fixo?</button>
            <div className="faq-answer">
              <p>
                Analisamos cada cenário. Pode ser mensalidade fixa, por número de alunos ou resultados.
                Entre em contato para entender qual modelo se adequa melhor à sua IES.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">8. Quais sistemas acadêmicos são compatíveis?</button>
            <div className="faq-answer">
              <p>
                Não se preocupe. A integração da CODI segue um modelo simples de importação de arquivos CSV,
                suportando a maioria dos ERPs e sistemas acadêmicos do mercado, inclusive quando são desenvolvidos
                internamente pela própria instituição.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">9. E se minha IES usa TOTVS?</button>
            <div className="faq-answer">
              <p>
                Já temos modelos prontos para exportar dados via webservice TOTVS, convertendo-os em CSV com criptografia
                e upload automáticos. A instituição só precisa configurar e ajustar esses modelos de consultas no webservice.
              </p>
            </div>
          </div>

          <div className="faq-item">
            <button onClick={showQuestion} className="faq-question">10. É possível personalizar os alertas e indicadores?</button>
            <div className="faq-answer">
              <p>
                Sim. Após a integração, ajudamos a configurar métricas específicas de cada instituição
                (faixas de notas e faltas, entregas de atividades, atrasos de pagamento, datas críticas,
                regras de fluxo entre os setores etc.).
              </p>
            </div>
          </div>
          
          <h3>Quer saber mais?</h3>
          <Link to="/contato" className="btn">Fale conosco</Link>

        </div>
      </section>
    </main>
  );
};

export default Faq;
